(function () {
  var api, dialog, fields, status, activated = false, busy = false, reloadScheduled = false;
  var eeaUK = 'AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE IS LI NO GB'.split(' ');
  function gpc() { return navigator.globalPrivacyControl === true; }
  function requiresConsent() { return api && (api.shouldShowBanner() || eeaUK.indexOf((api.getRegion() || '').slice(0, 2)) !== -1); }
  function advertisingAllowed() {
    if (!api || gpc() || !api.analyticsProcessingAllowed() || !api.marketingAllowed() || !api.saleOfDataAllowed()) return false;
    var c = api.currentVisitorConsent();
    return !requiresConsent() || (c.analytics === 'yes' && c.marketing === 'yes');
  }
  function googleConsent() {
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    var advertising = advertisingAllowed();
    window.gtag('consent', 'update', { analytics_storage: api.analyticsProcessingAllowed() ? 'granted' : 'denied', ad_storage: advertising ? 'granted' : 'denied', ad_user_data: advertising ? 'granted' : 'denied', ad_personalization: advertising ? 'granted' : 'denied' });
  }
  function activateScripts() {
    if (!advertisingAllowed()) return;
    document.querySelectorAll('script[data-seame-consent="advertising"]').forEach(function (old) {
      var script = document.createElement('script');
      Array.prototype.forEach.call(old.attributes, function (attribute) {
        if (attribute.name !== 'type' && attribute.name !== 'data-seame-consent') script.setAttribute(attribute.name, attribute.value);
      });
      script.textContent = old.textContent;
      old.replaceWith(script);
      activated = true;
    });
  }
  function reflect() {
    var c = api.currentVisitorConsent();
    dialog.querySelectorAll('[data-seame-purpose]').forEach(function (input) {
      var purpose = input.getAttribute('data-seame-purpose');
      input.disabled = gpc() && (purpose === 'marketing' || purpose === 'sale_of_data');
      input.checked = !input.disabled && c[purpose] === 'yes';
    });
    dialog.querySelector('[data-seame-gpc]').hidden = !gpc();
  }
  function show(customize) {
    fields.hidden = !customize;
    if (api) reflect();
    if (!dialog.open) { if (customize) dialog.showModal(); else dialog.show(); }
  }
  function clearAdvertisingIdentifiers() {
    document.cookie.split(';').forEach(function (part) {
      var name = part.split('=')[0].trim();
      if (!/^(?:_ga(?:_|$)|_gcl_|_fbp$|_fbc$|_ttp$|__kla_id$|ssn_|_adnabu_uid$)/.test(name)) return;
      var parts = location.hostname.split('.'), domains = [location.hostname, '.' + location.hostname];
      if (parts.length > 2) domains.push('.' + parts.slice(-2).join('.'));
      document.cookie = name + '=; Max-Age=0; path=/; SameSite=Lax';
      domains.forEach(function (domain) { document.cookie = name + '=; Max-Age=0; path=/; domain=' + domain + '; SameSite=Lax'; });
    });
    try { Object.keys(localStorage).forEach(function (key) { if (/^(?:TriplePixel|ssn_|di_pmt_wt)/.test(key)) localStorage.removeItem(key); }); } catch (_) {}
  }
  function saveChoices(choices) {
    if (!api || busy) { status.textContent = status.dataset.error; return; }
    if (gpc()) { choices.marketing = false; choices.sale_of_data = false; }
    busy = true; status.textContent = '';
    var settled = false;
    var timer = setTimeout(function () { if (!settled) { settled = true; busy = false; status.textContent = status.dataset.error; } }, 10000);
    try {
      api.setTrackingConsent(choices, function () {
        if (settled) return;
        settled = true; clearTimeout(timer); busy = false;
        var c = api.currentVisitorConsent();
        var ok = Object.keys(choices).every(function (purpose) { return c[purpose] === (choices[purpose] ? 'yes' : 'no'); });
        status.textContent = status.dataset[ok ? 'success' : 'error'];
        if (!ok) return;
        googleConsent(); reflect();
        if (!advertisingAllowed()) clearAdvertisingIdentifiers();
        if (activated && !advertisingAllowed()) { if (!reloadScheduled) { reloadScheduled = true; location.reload(); } return; }
        activateScripts();
        if (advertisingAllowed() && dialog.open) dialog.close();
      });
    } catch (_) { settled = true; clearTimeout(timer); busy = false; status.textContent = status.dataset.error; }
  }
  function ready() {
    api = window.Shopify.customerPrivacy;
    if (gpc()) {
      var c = api.currentVisitorConsent();
      if (c.marketing !== 'no' || c.sale_of_data !== 'no') api.setTrackingConsent({ marketing: false, sale_of_data: false }, function () { reflect(); googleConsent(); clearAdvertisingIdentifiers(); });
    }
    reflect(); googleConsent(); activateScripts();
    var consent = api.currentVisitorConsent();
    // Shopify's native banner collects the initial EEA/UK consent. These controls remain available for later changes.
    if (location.pathname.endsWith('/pages/data-sale-opt-out')) show(true);
    document.addEventListener('visitorConsentCollected', function () {
      googleConsent(); reflect();
      if (!advertisingAllowed()) clearAdvertisingIdentifiers();
      if (activated && !advertisingAllowed()) { if (!reloadScheduled) { reloadScheduled = true; location.reload(); } return; }
      activateScripts();
    });
  }
  function init() {
    dialog = document.getElementById('seame-privacy-dialog');
    if (!dialog) return;
    fields = document.getElementById('seame-privacy-fields'); status = dialog.querySelector('[data-seame-privacy-status]');
    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-seame-privacy-open]')) { show(true); return; }
      if (event.target.closest('[data-seame-privacy-close]')) { dialog.close(); return; }
      if (event.target.closest('[data-seame-privacy-optout]')) { show(true); saveChoices({ marketing: false, sale_of_data: false }); return; }
      var button = event.target.closest('[data-seame-action]');
      if (!button) return;
      var action = button.getAttribute('data-seame-action');
      if (action === 'customize') { show(true); return; }
      if (action === 'optout') { saveChoices({ marketing: false, sale_of_data: false }); return; }
      var choices = {};
      dialog.querySelectorAll('[data-seame-purpose]').forEach(function (input) { choices[input.getAttribute('data-seame-purpose')] = action === 'accept' || (action === 'save' && input.checked); });
      saveChoices(choices);
    });
    if (window.Shopify && window.Shopify.customerPrivacy) { ready(); return; }
    if (!window.Shopify || !window.Shopify.loadFeatures) { status.textContent = status.dataset.error; return; }
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) { if (error || !window.Shopify.customerPrivacy) { status.textContent = status.dataset.error; return; } ready(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
